import UnstyledLayout from "../../../../src/components/unstyled-layout";
import Seo from "../../../../src/components/seo";
import * as React from 'react';
export default {
  UnstyledLayout,
  Seo,
  React
};